exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-confirmation .modal-container {\n  width: 900px;\n}\n.modal-confirmation .modal-container .image {\n  height: 500px;\n  display: block;\n}\n.modal-confirmation .modal-container .image img {\n  height: 100%;\n}\n", ""]);

// exports
